// Filter registration. main.ts calls this once on startup.
import { registerLayer, getLayerSpec } from '@/core/pipeline';
import type { LayerKind } from '@/core/types';
import { paletteSpec } from './palette/quantize';
import { ditherSpec } from './dither';
import { posterizeSpec } from './posterize';
import { thresholdSpec } from './threshold';
import { symmetrySpec } from './symmetry';
import { halftoneSpec } from './halftone';

const ALL = [
  paletteSpec,
  ditherSpec,
  posterizeSpec,
  thresholdSpec,
  symmetrySpec,
  halftoneSpec,
];

export function registerAllFilters(): void {
  for (const spec of ALL) {
    if (!getLayerSpec(spec.kind)) registerLayer(spec);
  }
}

export const FILTER_KINDS: LayerKind[] = ALL.map((s) => s.kind);
